export class CodeDesignation {
	code: string | undefined;
	designation: string | undefined;

	constructor(code?: string, designation?: string) {
		this.code = code;
		this.designation = designation;
	}
}
